import { AfterViewInit, Component, EventEmitter, HostListener, inject, OnInit, Output, ViewChild } from '@angular/core'
import { ReferenceService } from '../../../sunleon/data-access/http/reference.service'
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms'
import { TypeReferenceDto } from '../../../sunleon/data-access/http/dto/type-reference-dto'
import { NgClass, NgForOf, NgIf } from '@angular/common'
import { NgSelectModule } from '@ng-select/ng-select'
import { BilanEnergetiqueService } from '../../../sunleon/data-access/http/bilan-energetique.service'
import { BilanEnergetiqueDto } from '../../../sunleon/data-access/http/dto/bilan-energetique-dto'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { ToastrService } from 'ngx-toastr'
import { FileUploadService } from '../../../sunleon/data-access/http/file-upload.service'
import { GeomapDomainService } from '../../domain/geomap.domain'
import { Subject, takeUntil } from 'rxjs'
import { User } from '../../../shared/models/user'
import { AuthService } from '../../../core/services/auth.service'
import { PieceJointeService } from 'src/app/sunleon/data-access/http/piece-jointe.service'
import saveAs from 'file-saver'
import { RaccordementPublic } from '../../model/zone-measures'
import { ConfirmationModalComponent } from '../modals/confirmation-modal/confirmation-modal.component'

@Component({
  selector: 'app-form-mode-valorisation',
  templateUrl: './form-mode-valorisation.component.html',
  styleUrls: ['./form-mode-valorisation.component.scss'],
  standalone: true,
  imports: [NgIf, FormsModule, NgForOf, ReactiveFormsModule, NgClass, NgSelectModule],
})
export class FormModeValorisationComponent implements OnInit, AfterViewInit {
  @Output()
  formReady: EventEmitter<FormGroup> = new EventEmitter<FormGroup>()

  user: User

  modeValorisationForm: FormGroup
  private readonly geomapDomainService = inject(GeomapDomainService)
  private unsubscribe$ = new Subject<void>()

  @ViewChild('content')
  modalContent: any

  modeValorisations: TypeReferenceDto[] = []
  mecanismesRevente: TypeReferenceDto[] = []
  prmCodes: BilanEnergetiqueDto[] = []
  formModalIsSubmitting: boolean = false
  formIsSubmitting: boolean = false
  selectedFile: File | undefined
  processIdEnregistrementSimulation: string | undefined
  status: string | undefined

  selectedFormat: 'sunleon' | 'enedis' | null = null;
  nomCourbeCharge: string = '';
  nomCourbeChargeError: boolean = false;

  constructor(
    public authService: AuthService,
    private bilanEnergetiqueService: BilanEnergetiqueService,
    private referenceService: ReferenceService,
    public modalService: NgbModal,
    private toastr: ToastrService,
    private fileUploadService: FileUploadService,
    private pieceJointeService : PieceJointeService,
    private formBuilder: FormBuilder
  ) {
    this.modeValorisationForm = this.formBuilder.group({
      modeValorisation: [null, [Validators.required]],
      puissanceSouscriteKVA: [null, [Validators.pattern('^\\d+$')]],
      travauxDistanceVoirieVrd: [null],
      mecanismeReventeSurplus: [null],
      dispoTGBT: [false],
      automate: [false],
      ptrAC: [false],
      prm: [null],
      tarifHch: [null],
      tarifHph: [null],
      tarifHpt: [null],
      tarifHpb: [null],
      tarifHcb: [null],
    })
  }

  ngAfterViewInit(): void {
    this.modeValorisationForm.get('modeValorisation').valueChanges.pipe(takeUntil(this.unsubscribe$))
      .subscribe(value => {
        this.onRadioChange(value);
      });
  }

  ngOnInit(): void {
    this.user = this.authService.connectedUser
    this.referenceService.getModeValorisation().subscribe((data) => {
      this.modeValorisations = data
    })
    this.referenceService.getMecanismeRevente().subscribe((data) => {
      this.mecanismesRevente = data
    })

    this.loadPrmCodes()


    this.initModeValorisation(
      'modeValorisation',
      'prm',
      'puissanceSouscriteKVA',
      'tarifHch',
      'tarifHph',
      'tarifHpt',
      'tarifHpb',
      'tarifHcb',
      'travauxDistanceVoirieVrd',
      'mecanismeReventeSurplus',
      'dispoTGBT',
      'automate',
      'ptrAC',
    )
    this.formReady.emit(this.modeValorisationForm)
  }

    onRadioChange(code: string | null) {
    if (code) {
      this.geomapDomainService.selectModeValorisationOutils(); 
    }
  }

  onRadioClick(code: string | null, controleName: string) {
    this.modeValorisationForm.get(controleName).setValue(code)
    this.geomapDomainService.selectModeValorisationOutils()
  }

openModal() {
    this.selectedFormat = null;
    this.nomCourbeCharge = '';
    this.nomCourbeChargeError = false;
    this.selectedFile = undefined;
    this.modalService
      .open(this.modalContent, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false })
      .result.then(
        () => {
          this.formModalIsSubmitting = false;
        },
        () => {
          this.formModalIsSubmitting = false;
        }
      );
  }

  onFormatChange(): void {
    this.nomCourbeCharge = '';
    this.nomCourbeChargeError = false;
    this.selectedFile = undefined; 
    this.validateNomCourbeCharge();
  }

  onFileSelected(event: Event): void {
    const inputElement = event.target as HTMLInputElement
    if (inputElement?.files) {
      this.selectedFile = inputElement.files[0]
    }
  }

  validateNomCourbeCharge(): void {
    this.nomCourbeChargeError = !this.nomCourbeCharge.trim();
  }

  onSubmit(): void {
    this.validateNomCourbeCharge();
    if (this.selectedFormat === 'enedis' && this.nomCourbeChargeError) {
        this.toastr.error('Le code PRM est requis pour le format Enedis');
        return;
    }
    if (!this.selectedFile) {
      this.toastr.error('Aucun fichier sélectionné');
      return;
    }
    if (this.selectedFile) {
      this.formModalIsSubmitting = true;
      this.pieceJointeService.uploadPieceJointeAndReturnDownloadUrl(this.selectedFile, this.nomCourbeCharge + '.csv').subscribe({
        next: (filename: string) => {
          this.fileUploadService.uploadFile(filename, this.selectedFormat === 'enedis').subscribe({
            next: (data: any) => {
              this.processIdEnregistrementSimulation = data.message
              this.monitorProcessStatus(this.processIdEnregistrementSimulation)
              this.formModalIsSubmitting = false;
              this.modalService.dismissAll();
              this.selectedFile = undefined;
              this.nomCourbeCharge = '';
            },
            error: (error) => {
              this.toastr.error('Erreur lors de la récupération du fichier pour son traitement : ' + (error.message || 'Erreur inconnue'));
              this.formModalIsSubmitting = false;
              this.modalService.dismissAll();
            }
          });
        },
        error: (error) => {
          this.toastr.error('Erreur lors de l\'upload du fichier vers S3 : ' + (error.message || 'Erreur inconnue'));
          this.formModalIsSubmitting = false;
          this.modalService.dismissAll();
        }
      });
    } else {
      this.toastr.error('Aucun fichier sélectionné');
      this.formModalIsSubmitting = false;
      this.modalService.dismissAll();
    }
  }

  monitorProcessStatus(processId: string) {
    this.fileUploadService.getProcessStatus(processId).subscribe((result) => {
      this.status = result.status
      if (this.status === 'COMPLETED') {
        this.formModalIsSubmitting = false
        //saveAs(result.urlCsv, result.nomCsv)
        this.toastr.success('Le fichier CSV a été importé avec le code PRM : ' + result.message)
        this.modeValorisationForm.get('prm').setValue(result.message)
        this.modalService.dismissAll()
        this.processIdEnregistrementSimulation = undefined
      } else {
        if (this.status === 'FAILED') {
          this.formModalIsSubmitting = false
          this.toastr.error(result.message)
          this.modalService.dismissAll()
          this.processIdEnregistrementSimulation = undefined
        } else {
          this.toastr.info(result.message)
        }
      }
    })
  }

  initModeValorisation(
    modeValorisation: string,
    prmAC: string,
    puissanceSouscriteKVAac: string,
    tarifHchAc: string,
    tarifHphAc: string,
    tarifHptAc: string,
    tarifHpbAc: string,
    tarifHcbAc: string,
    distanceVoirieVRD: string,
    mecanismeReventeSurplusAC: string,
    dispoTGBTAC: string,
    automateAC: string,
    ptrACAC: string,
  ) {
    this.modeValorisationForm.get(modeValorisation).valueChanges.subscribe((mode) => {
      const prm = this.modeValorisationForm.get(prmAC)
      const puissanceSouscriteKVA = this.modeValorisationForm.get(puissanceSouscriteKVAac)
      const tarifHch = this.modeValorisationForm.get(tarifHchAc)
      const tarifHph = this.modeValorisationForm.get(tarifHphAc)
      const tarifHpt = this.modeValorisationForm.get(tarifHptAc)
      const tarifHpb = this.modeValorisationForm.get(tarifHpbAc)
      const tarifHcb = this.modeValorisationForm.get(tarifHcbAc)
      const distanceVoirie = this.modeValorisationForm.get(distanceVoirieVRD)
      const mecanismeReventeSurplus = this.modeValorisationForm.get(mecanismeReventeSurplusAC)
      const dispoTGBT = this.modeValorisationForm.get(dispoTGBTAC)
      const automate = this.modeValorisationForm.get(automateAC)
      const ptrAC = this.modeValorisationForm.get(ptrACAC)

      if (mode === 'AC') {
        prm.setValidators([Validators.required])
        puissanceSouscriteKVA.setValidators([Validators.required])
        tarifHch.setValidators([Validators.required])
        tarifHph.setValidators([Validators.required])
        tarifHpt.setValidators([Validators.required])
        tarifHpb.setValidators([Validators.required])
        tarifHcb.setValidators([Validators.required])
        //mecanismeReventeSurplus.setValidators([Validators.required])
      } else {
        prm.setValidators([Validators.nullValidator])
        puissanceSouscriteKVA.setValidators([Validators.nullValidator])
        tarifHch.setValidators([Validators.nullValidator])
        tarifHph.setValidators([Validators.nullValidator])
        tarifHpt.setValidators([Validators.nullValidator])
        tarifHpb.setValidators([Validators.nullValidator])
        tarifHcb.setValidators([Validators.nullValidator])
        prm.reset()
        puissanceSouscriteKVA.reset()
        distanceVoirie.reset()
        tarifHch.reset()
        tarifHph.reset()
        tarifHpt.reset()
        tarifHpb.reset()
        tarifHcb.reset()
        mecanismeReventeSurplus.reset()
        dispoTGBT.setValue(false)
        automate.setValue(false)
        ptrAC.setValue(false)
      }

      mecanismeReventeSurplus.updateValueAndValidity()
    })
  }

  isPrmDropdownOpen = false;

  selectPrm(code: string): void {
    this.modeValorisationForm.get('prm')?.setValue(code);
    this.isPrmDropdownOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.custom-select-trigger') && !target.closest('.custom-select-panel')) {
      this.isPrmDropdownOpen = false;
    }
  }

  deletePrm(event: MouseEvent, codePrm: string): void {
    event.stopPropagation()
    event.preventDefault()

    const modalRef = this.modalService.open(ConfirmationModalComponent)
    modalRef.componentInstance.titre = 'Suppression du PRM'
    modalRef.componentInstance.message = `Le PRM ${codePrm} et toutes ses lignes de courbe de charge seront supprimés.`
    modalRef.componentInstance.confirmation = 'Voulez-vous continuer ?'

    modalRef.result.then((confirmed: boolean) => {
      if (!confirmed) return
      this.bilanEnergetiqueService.deletePrm(codePrm).subscribe({
        next: () => {
          if (this.modeValorisationForm.get('prm')?.value === codePrm) {
            this.modeValorisationForm.get('prm')?.reset()
          }
          this.toastr.success(`Le PRM ${codePrm} a été supprimé.`)
          this.loadPrmCodes() // recharge la liste à jour depuis le backend
        },
        error: () => {
          this.toastr.error(`Erreur lors de la suppression du PRM ${codePrm}.`)
        },
      })
    },  (): void => {}
)
  }

  loadPrmCodes(): void {
    this.bilanEnergetiqueService.getPrm().subscribe((data) => {
      this.prmCodes = data
    })
  }
  
}
